import React, { useState } from 'react';
import { useChatStore } from '../../stores/useChatStore';
import './SessionSidebar.css';

interface Props {
  onNewSession?: () => void; // unused, kept for API stability
}

export default function SessionSidebar(_props: Props) {
  const {
    sessions,
    currentSessionId,
    selectSession,
    deleteSession,
    renameSession,
    createSession,
    models,
    defaultModel
  } = useChatStore();
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editTitle, setEditTitle] = useState('');
  const [pickerOpen, setPickerOpen] = useState(false);

  function startRename(id: string, currentTitle: string) {
    setEditingId(id);
    setEditTitle(currentTitle);
  }

  async function commitRename(id: string) {
    const title = editTitle.trim();
    if (title) await renameSession(id, title);
    setEditingId(null);
  }

  async function newSessionWith(modelKey: string) {
    setPickerOpen(false);
    const sess = await createSession(modelKey);
    await selectSession(sess._id);
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-new-wrap">
        <button className="sidebar-new" onClick={() => setPickerOpen((o) => !o)}>
          + Neue Unterhaltung
        </button>
        {pickerOpen && (
          <div className="sidebar-model-picker">
            <div className="sidebar-model-picker-title">Modell wählen</div>
            {models.length === 0 && <div className="sidebar-model-empty">Lädt…</div>}
            {models.map((m) => (
              <button
                key={m.key}
                className={`sidebar-model-option ${m.key === defaultModel ? 'default' : ''}`}
                onClick={() => newSessionWith(m.key)}
              >
                <span className="sidebar-model-name">{m.label}</span>
                <span className="sidebar-model-price">
                  ${m.inputPerM.toFixed(2)} / ${m.outputPerM.toFixed(2)} pro 1M
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="sidebar-list">
        {sessions.length === 0 && <div className="sidebar-empty">Noch keine Unterhaltungen</div>}
        {sessions.map((s) => (
          <div
            key={s._id}
            className={`sidebar-item ${s._id === currentSessionId ? 'active' : ''}`}
            onClick={() => selectSession(s._id)}
          >
            <div className="sidebar-item-main">
              {editingId === s._id ? (
                <input
                  className="sidebar-item-input"
                  autoFocus
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  onBlur={() => commitRename(s._id)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') commitRename(s._id);
                    else if (e.key === 'Escape') setEditingId(null);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              ) : (
                <span
                  className="sidebar-item-title"
                  onDoubleClick={(e) => {
                    e.stopPropagation();
                    startRename(s._id, s.title);
                  }}
                  title={s.title}
                >
                  {s.title}
                </span>
              )}
              <span className="sidebar-item-cost">${s.totalCostUsd.toFixed(4)}</span>
            </div>
            <button
              className="sidebar-item-del"
              onClick={(e) => {
                e.stopPropagation();
                if (window.confirm('Diese Unterhaltung wirklich löschen?')) deleteSession(s._id);
              }}
              aria-label="Löschen"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </aside>
  );
}
